export const statusCode400 = 400;
export const statusCode401 = 401;
export const statusCode403 = 403;
export const statusCode404 = 404;
export const statusCode428 = 428;
export const statusCode500 = 500;
